<script>
	import {onDestroy} from "svelte";
	import './core/ecommerce.js';
	import {
		cartItemsStore,
		cartTotalStore,
		addToCartHandler,
		addToCartWithPriceHandler,
		removeFromCartHandler,
		removeFromCartWithPriceHandler,
		loadCart
	} from "./cart/cart-store.js";
	import {
		filterAllergens,
		loadFavorites,
		favsStore,
		filtersStore,
		publishConfigStore, tenantKeyStore, menuStore, menuRecordsCountStore, resetFilterFavorites
	} from "./core/app-store.js";
	import {
		closeAllergensFilterPanel,
		toggleDetailsScreen,
		openCartScreen,
		closeCartScreen,
		screensStore, closeSearchPanel
	} from "./core/screens-manager.js";
	import {sanitizeText, scrollToElementId} from "./core/utils.js";
	import Filters from "./components/Filters.svelte";
	import DetailsScreen from "./details/DetailsScreen.svelte";
	import Sections from "./components/Sections.svelte";
	import RecordListItem from "./components/RecordListItem.svelte";
	import CartWidget from "./cart/CartWidget.svelte";
	import CartScreen from "./cart/CartScreen.svelte";
	import {previewListener} from "./core/preview.js";
	import TextBlock from "./components/TextBlock.svelte";
	import SectionTitle from "./components/SectionTitle.svelte";
	import RecordCard from "./components/RecordCard.svelte";
	import Header from "./components/Header.svelte";
	import OrderScreen from "./orders/OrderScreen.svelte";
	import OrderPlacementResultScreen from "./orders/OrderPlacementResultScreen.svelte";
	import SearchPanel from "./components/SearchPanel.svelte";
	import EditDetailsHalfScreen from "./details/EditDetailsHalfScreen.svelte";
	import GalleryLightbox from "./components/GalleryLightbox.svelte";
	import DoubleCard from "./components/DoubleCard.svelte";
	import PromoCard from "./components/PromoCard.svelte";
	import Footer from "./components/Footer.svelte";
	import DMLabel from "./components/DMLabel.svelte";
	import LanguageSwitcher from './components/LanguageSwitcher.svelte';
	import { t } from './core/i18n/language-store';
	import {registerServiceWorker, updateApp} from "./core/pwa.js";
	import Notification from './components/Notification/Notification.svelte';
	import DocsBlock from "./components/DocsBlock.svelte";

	loadCart();

	const publishConfig = M.publishConfig;
	let tenantKey;
	let favoritesList = [];
	let screens = {};
	let nothingFound;
	let menuIsEmpty = false;

	let menu = JSON.parse(JSON.stringify(M.menu));

	const uns1 = favsStore.subscribe(list => {

		favoritesList = list;

		menuStore.update(menu => {
			menu.sections.forEach(section => {
				(section.records || []).forEach(r => {
					r.isFavorite = favoritesList.includes(r.id);
				});
			});

			return {...menu};
		})
	});

	const applyFilter = (filters) => {

		menuStore.update(menu => {
			menu.sections.forEach(s => {
				(s.records || []).forEach((r, i) => {
					const intersectedCount = (r.allergens || []).filter(a => filters.allergens.indexOf(a) > -1).length;
					const allergenFilter = intersectedCount !== 0;
					const favoritesFilter = filters.favorites === true && !favoritesList.includes(r.id);

					// clear old search result
					let searchTextFilter = false;
					r._found_desc = undefined;

					/// search by text
					if (filters.searchText && (r.name || r.description)) {

						/// search in name
						if (!r._name_lowcase) {
							r._name_lowcase = (r.name || '').toLowerCase();
						}

						searchTextFilter = r._name_lowcase.indexOf(filters.searchText) === -1;

						/// if not found, search in description
						if (searchTextFilter) {

							if (!r._description_lowcase) {
								r._description_lowcase = (r.description || '').toLowerCase();
							}

							if (r._description_lowcase.length > 0) {
								searchTextFilter = r._description_lowcase.indexOf(filters.searchText) === -1;
								if (!searchTextFilter) {
									r._found_desc = sanitizeText(r.description).replace(filters.searchText, `<em>${filters.searchText}</em>`);
								}
							}
						}
					}
					else if (!r.name || r.name.length === 0) {
						searchTextFilter = true;
					}

					r.isFilteredOut = allergenFilter || favoritesFilter || searchTextFilter;
				});

				s.isFilteredOut = (s.records || []).filter(r => !r.isFilteredOut).length === 0;
			});

			nothingFound = (menu.sections || []).filter(s => !s.isFilteredOut && s.sectionType !== 'text-block').length === 0;
			return {...menu};
		});
	}

	const unsM = menuStore.subscribe(x => {
		menu = x;

		if (screens.detailsRecord !== null && screens.detailsRecord !== undefined) {
			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					if (r.id === screens.detailsRecord.id) {
						screensStore.update(s => {
							s.detailsRecord = r;
							return s;
						})
					}
				})
			})
		}
	});
	const unsS = screensStore.subscribe(s => {
		screens = s;

		/// block body scrolling
		const hasOpenedScreens = s.detailsOpened || s.cartOpened || s.orderFormOpened || s.orderPlacementResultOpened;
		document.body.style.overflow = hasOpenedScreens ? 'hidden' : 'initial';
	});
	const unsF = filtersStore.subscribe(filters => applyFilter(filters));
	const unsT = tenantKeyStore.subscribe(key => tenantKey = key);
	const unsR = menuRecordsCountStore.subscribe(x => {
		menuIsEmpty = x === 0;
	});

	const unsC = cartItemsStore.subscribe(cartItems => {


		const _map = {};
		(cartItems || []).forEach(cartItem => {
			let key = `${cartItem.id}::${cartItem.priceIndex}`; // recordId::priceIndex
			if (!_map[key]) {
				_map[key] = +cartItem.count;
			}
			else {
				_map[key] = _map[key] + cartItem.count;
			}
		});

		menuStore.update(menu => {

			(menu.sections || []).forEach(s => {
				(s.records || []).forEach(r => {
					r._orderedItems = 0;
					r.prices.forEach((p, idx) => {

						let key = `${r.id}::${idx}`;
						p._count = _map[key];
						r._orderedItems += (_map[key] || 0);
					});
				});
			});

			return {...menu};
		});
	});

	loadFavorites(menu);

	onDestroy(() => {
		uns1();
		unsM();
		unsS();
		unsF();
		unsT();
		unsC();
		unsR();
	});

	const scrollToElementIdHandler = (id) => {

		closeSearchPanel();
		resetFilterFavorites();
		setTimeout(() => {scrollToElementId(id);}, 200);
	}

	previewListener();

	/// Check PWA updates
	let showUpdateNotification = false;
	registerServiceWorker(() => {
		showUpdateNotification = true;
	});

</script>

<style>

	main {
		flex: 1 1;
	}
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		flex: 1;
		gap: 24px;
	}
	.filters-container {
		flex: 1 1;
		padding: 0 1rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 48px;
	}
	.content {
		padding: 0 1rem;
	}
	.section {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		margin: 0;
	}
	.separator--sections {
        margin: 24px 0;
    }
	.cart-space {
		height: 3.5rem;
	}

	.no-found-panel {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 2.75rem 1.25rem 2.75rem 1.25rem;

		font-family: Roboto Condensed, sans-serif;
		text-transform: uppercase;
		font-size: 32px;
		font-weight: 800;
		color: var(--accent-color);
	}

	@media (min-width: 768px) {
		main {
			display: flex;
			justify-content: center;
		}
		.filters-container {
			display: flex;
			justify-content: center;
			padding: 0;
		}
		.content {
			padding: 0;
		}
		.section {
			gap: 28px;
		}
	}

	.update-notification {
		position: fixed;
		top: 16px;
		right: 16px;
		background: var(--accent-color);
		color: white;
		padding: 16px;
		border-radius: 4px;
		z-index: 1000;
		display: flex;
		gap: 16px;
		align-items: center;
	}
	
	.update-notification button {
		background: white;
		color: var(--accent-color);
		border: none;
		padding: 8px 16px;
		border-radius: 4px;
		cursor: pointer;
	}
</style>

<CartWidget total={$cartTotalStore}
			showTotal={$publishConfigStore.userCanSeeTotal}
			publishConfig={$publishConfigStore}
			on:openCartScreen={openCartScreen}>
</CartWidget>

<DetailsScreen></DetailsScreen>

<EditDetailsHalfScreen></EditDetailsHalfScreen>

<CartScreen showTotal={$publishConfigStore.userCanSeeTotal}
			on:close={closeCartScreen}>
</CartScreen>

<OrderScreen publishConfig={$publishConfigStore}></OrderScreen>

<OrderPlacementResultScreen></OrderPlacementResultScreen>

<!-- HEADER -->
<Header></Header>

<!-- MAIN CONTENT -->
<main class="layer-sections flex-column" id="dm-menu">

	<LanguageSwitcher />

	<!-- NAV -->
	<Sections opened={$screensStore.sectionsOpened}
				sections={menu.sections}
				favoritesList={favoritesList}
				on:scrollToSection={(e) => scrollToElementIdHandler(e?.detail?.id)}>
	</Sections>

	<!-- FILTER CONTENT: ALLERGENS -->
	<div class="filters-container">
		<div class="container_768 container_960 container_1600">
			<Filters opened={$screensStore.filtersOpened}
					 on:filter={filterAllergens}
					 on:close={closeAllergensFilterPanel}>
			</Filters>
		</div>
	</div>

	<!-- SEARCH PANEL -->
	<div class="filters-container">
		<div class="container_768 container_960 container_1600">
			<SearchPanel></SearchPanel>
		</div>
	</div>

	<!-- MAIN -->
	<div class="main">

	{#if (nothingFound && !menuIsEmpty)}
		<div class="no-found-panel">{$t('search.nothingFound')}</div>
	{/if}

	<!-- MENU SECTIONS & ITEMS -->
	{#each menu.sections as section, idx}
		{#if (section.isFilteredOut !== true || section.sectionType === 'text-block' )}

			{#if (section.sectionType === 'text-block')}
				{#if (idx !== 0)}
					<div class="container_768 container_960 container_1600">
						<hr class="separator separator--sections">
					</div>
				{/if}
				<div class="container_768 container_960 container_1600">
					<TextBlock section="{section}" tenantKey="{tenantKey}"/>
				</div>
			{:else}
				<div id={section.id} class="content container_768 container_960 container_1600">
					<SectionTitle section="{section}" hideScrollToTop="{idx === 0}"/>
					<section class="section desktop-grid">
					{#each section.records as record, i }
						{#if (record.isFilteredOut !== true)}

							{#if (section.sectionType === 'list' || record.recordType === 'list-item')}
								<RecordListItem record={record}
												publishConfig={publishConfig}
												tenantKey={tenantKey}
												on:removeFromCartWithPrice={(e) => removeFromCartWithPriceHandler(e.detail)}
												on:addToCartWithPrice={(e) => addToCartWithPriceHandler(e.detail)}>
								</RecordListItem>
							{:else if record.promoted?.enabled === true}
								<PromoCard record={record}
										   publishConfig={publishConfig}
										   tenantKey={tenantKey}
										   cardHeight="{section.cardHeight}"
										   reverse={i % 2 === 0}
										   on:toggleDetailsScreen={(record) => toggleDetailsScreen(record.detail)}
										   on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
										   on:addToCart={(record) => addToCartHandler(record.detail)}>
								</PromoCard>
							{:else if record.recordType === 'double-card'}
								<DoubleCard record={record}
											publishConfig={publishConfig}
											tenantKey={tenantKey}
											cardHeight="{section.cardHeight}"
											on:toggleDetailsScreen={(record) => toggleDetailsScreen(record.detail)}
											on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
											on:addToCart={(record) => addToCartHandler(record.detail)}>
								</DoubleCard>
							{:else}
								<RecordCard record={record}
											publishConfig={publishConfig}
											tenantKey={tenantKey}
											cardHeight="{section.cardHeight}"
											on:toggleDetailsScreen={(record) => toggleDetailsScreen(record.detail)}
											on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
											on:addToCart={(record) => addToCartHandler(record.detail)}>
								</RecordCard>
							{/if}
						{/if}
					{/each}
					</section>
				</div>
			{/if}

		{/if}
	{/each}

	</div>
</main>

<footer class="flex-column ai-center full-width" style="gap: 36px; padding-top: 48px;">
	<div class="full-width container_768 container_960 container_1600">
		<hr class="separator separator--sections">
	</div>
	<div class="full-width container_768 container_960 container_1600">
		<Footer publishConfig={$publishConfigStore}
				tenantKey={tenantKey}>
		</Footer>
		<DocsBlock></DocsBlock>
	</div>
</footer>

<DMLabel tenantKey={tenantKey}></DMLabel>

{#if ($cartTotalStore?.count > 0)}
	<div class="cart-space"></div>
{/if}

<GalleryLightbox tenantKey={tenantKey}></GalleryLightbox>

<!-- UPDATE NOTIFICATION -->
{#if showUpdateNotification}
	<div class="update-notification">
		<p>{$t('app.newVersionAvailable')}</p>
		<button on:click={updateApp}>{$t('app.update')}</button>
	</div>
{/if}

<Notification />
